import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { NewsCategoriesRoutingModule } from './news-categories-routing.module';
import { NewsCategoriesListComponent } from './news-categories-list/news-categories-list.component';
import { NewsCategoriesCreateComponent } from './news-categories-create/news-categories-create.component';

@NgModule({
  declarations: [NewsCategoriesListComponent, NewsCategoriesCreateComponent],
  imports: [
    CommonModule,
    NewsCategoriesRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class NewsCategoriesModule { }
